module.exports = __webpack_public_path__ + "static/media/a6-l.d7d6d2b4.png";